import { IconType } from "react-icons";
import { RiDashboardFill, RiUserSearchFill } from "react-icons/ri";
import { AiFillWarning } from 'react-icons/ai';
import Dashboard from "../pages/Internal/Dashboard";
import { HiDocumentSearch } from "react-icons/hi";
import DocumentsReview from "../pages/Internal/DocumentsReview";
import UserActivity from "../pages/Internal/UserActivity";
import CategorizationHelp from "../pages/Internal/CategorizationHelp";
import IntegratedPastData from "../pages/Internal/IntegratedPastData";
import ExceptionManagement from "../pages/Internal/ExceptionManagement";
import EmailInbox from "../pages/Internal/EmailInbox";
import PurchaseDocuments from "../pages/Internal/PurchaseDocuments";
import SalesDocuments from "../pages/Internal/SalesDocuments";
import BankStatements from "../pages/Internal/BankStatements";
import SplittedDocuments from "../pages/Internal/SplittedDocuments";
import InProcess from "../pages/Internal/InProcess";
import { MdMail } from "react-icons/md";
import { GiWallet } from "react-icons/gi";
import { FaHubspot, FaTrash } from "react-icons/fa";
import DashboardSupervisor from "../pages/Internal/Dashboard/DashboardSupervisor";
import BillingHistory from "../pages/Internal/BillingHistory";
import DeletedDocuments from "../pages/Internal/DeletedDocuments";
import OtherDocuments from "../pages/Internal/OtherDocuments";
import DocumentsProcessingSummary from "../pages/Internal/DocumentsProcessingSummary";
import HubspotSync from "../pages/Internal/HubspotSync";
import ExportErrors from "../pages/Internal/ExportErrors";
import TempDisconnectedEntities from "../pages/Internal/TempDisconnectedEntities";
import UploadErrors from "../pages/Internal/UploadErrors";
import UserRoles from "../pages/Internal/UserRoles";
import NotificationSettings from "../pages/Internal/NotificationSettings";
import ComingSoon from "../pages/ComingSoon";

export interface InternalSidebarItemType {
    tooltipText?: string;
    Icon?: IconType;
    link: string;
    selected?: boolean;
    element: () => JSX.Element;
    hide?: Boolean;
    id:number;
    /** Show the Coming Soon placeholder instead of the real page. */
    comingSoon?: boolean | string;
}

/**
 * Pass any list of internal sidebar items through this and items marked
 * `comingSoon` will render the placeholder page in place of their element.
 */
export function applyComingSoon(items: InternalSidebarItemType[]): InternalSidebarItemType[] {
    return items.map(item => {
        if (!item.comingSoon) return item;
        const eta = typeof item.comingSoon === 'string' ? item.comingSoon : undefined;
        const Page = () => <ComingSoon title="Coming Soon" eta={eta} />;
        return { ...item, element: Page };
    });
}

const DataEntryLinksRaw: InternalSidebarItemType[] = [
    {   
        id:1,
        tooltipText: "Dashboard",
        Icon: RiDashboardFill,
        link: "/internal/dashboard",
        element: Dashboard
    },
    {
        id:2,
        tooltipText: "Document Review",
        Icon: HiDocumentSearch,
        link: "/internal/documents-review",
        element: DocumentsReview
    },
    {
        id:3,
        tooltipText: "User Activity",
        Icon: RiUserSearchFill,
        link: "/internal/users-activity",
        element: UserActivity,
    },
    {   
        id:4,
        tooltipText: "Exception Management",
        Icon: AiFillWarning,
        link: "/internal/exception-management",
        element: ExceptionManagement
    },
    // {
    //     tooltipText: "Export Errors",
    //     Icon: RiFolderWarningFill,
    //     link: "/internal/export-errors",
    //     element: BankStatements
    // },
    {
        id:5,
        link: "/internal/categorization-help",
        element: CategorizationHelp,
        hide: true
    },
    {
        id:6,
        link: "/internal/integrated-past-data",
        element: IntegratedPastData,
        hide: true
    },
    {
        id:7,
        link: "/internal/email-inbox",
        element: EmailInbox,
        hide: true
    },
    {
        id:8,
        link: "/internal/PurchaseDocuments/:id",
        element: PurchaseDocuments,
        hide: true
    },
    {
        id:9,
        link: "/internal/SalesDocuments/:id",
        element: SalesDocuments,
        hide: true
    },
    {
        id:10,
        link: "/internal/bank-statements",
        element: BankStatements,
        hide: true
    },
    {
        id:11,
        link: "/internal/other-documents/:id",
        element: OtherDocuments,
        hide: true
    },
    {
        id:12,
        link: "/internal/splitted-documents",
        element: SplittedDocuments,
        hide: true
    },
    {
        id:13,
        link: "/internal/in-process",
        element: InProcess,
        hide: true
    }
]

const SupervisorLinksRaw: InternalSidebarItemType[] = [
    {
        id:1,
        tooltipText: "Dashboard",
        Icon: RiDashboardFill,
        link: "/internal/dashboard",
        element: DashboardSupervisor
    },
    {
        id:2,
        tooltipText: "Document Review",
        Icon: HiDocumentSearch,
        link: "/internal/documents-review",
        element: DocumentsReview
    },
    {
        id:3,
        tooltipText: "Processed Documents Summary",
        Icon: MdMail,
        link: "/internal/processed-documents-summary",
        element: DocumentsProcessingSummary
    },
    {
        id:4,
        tooltipText: "Billing History",
        Icon: GiWallet,
        link: "/internal/billing-history",
        element: BillingHistory,
        comingSoon: true,
    },
    {
        id:5,
        tooltipText: "Deleted Documents",
        Icon: FaTrash,
        link: "/internal/deleted-documents",
        element: DeletedDocuments
    },
    {
        id:6,
        tooltipText: "User Activity",
        Icon: RiUserSearchFill,
        link: "/internal/users-activity",
        element: UserActivity,
    },
    {
        id:7,
        link: "/internal/exception-management",
        element: ExceptionManagement,
        hide: true,
    },
    {
        id:8,
        link: "/internal/export-errors",
        element: ExportErrors,
        hide: true,
        comingSoon: true,
    },
    {
        id:9,
        tooltipText: 'Hubspot Sync',
        Icon: FaHubspot,
        link: '/internal/hubspot-sync',
        element: HubspotSync,
        comingSoon: true,
    },
    {
        id:10,
        link: "/internal/categorization-help",
        element: CategorizationHelp,
        hide: true
    },
    {
        id:11,
        link: "/internal/temp-disconnected-entities",
        element: TempDisconnectedEntities,
        hide: true
    },
    {
        id:12,
        link: "/internal/integrated-past-data",
        element: IntegratedPastData,
        hide: true
    },
    {
        id:13,
        link: "/internal/email-inbox",
        element: EmailInbox,
        hide: true
    },
    {
        id:14,
        link: "/internal/upload-errors",
        element: UploadErrors,
        hide: true
    },
    {
        id:15,
        link: "/internal/user-roles",
        element: UserRoles,
        hide: true
    },
    {
        id:16,
        link: "/internal/notification-settings",
        element: NotificationSettings,
        hide: true
    },
    {
        id:17,
        link: "/internal/PurchaseDocuments/:id",
        element: PurchaseDocuments,
        hide: true
    },
    {
        id:18,
        link: "/internal/SalesDocuments/:id",
        element: SalesDocuments,
        hide: true
    },
    {
        id:19,
        link: "/internal/bank-statements",
        element: BankStatements,
        hide: true
    },
    {
        id:20,
        link: "/internal/other-documents/:id",
        element: OtherDocuments,
        hide: true
    },
    {
        id:20,
        link: "/internal/splitted-documents",
        element: SplittedDocuments,
        hide: true
    },
    {
        id:21,
        link: "/internal/in-process",
        element: InProcess,
        hide: true
    }
]

// Export wrapped versions — items with `comingSoon: true` render the placeholder.
export const DataEntryLinks: InternalSidebarItemType[] = applyComingSoon(DataEntryLinksRaw);
export const SupervisorLinks: InternalSidebarItemType[] = applyComingSoon(SupervisorLinksRaw);